<div class="container d-flex justify-content-center p-3 flex-wrap flex-row">

  <!-- Nas tim -->
  <div class="slike order-m-2 p-2 ">
    <div class="d-flex flex-wrap flex-column nastim p-1">
      <h5>Naš tim:</h5>
      <div class="card mb-3">
        <img class="card-img-top" src="../../assets/amar.png" alt="Card image cap">
        <div class="card-body">
          <p class="card-text text-center">Amar Alibegović</p>
        </div>
      </div>
      <div class="card mb-3">
        <img class="card-img-top" src="../../assets/grealish.jpg" alt="Card image cap">
        <div class="card-body">
          <p class="card-text text-center">Jack Grealish</p>
        </div>
      </div>
      <div class="card">
        <img class="card-img-top" src="../../assets/lebron.jpg" alt="Card image cap">
        <div class="card-body">
          <p class="card-text text-center">Lebron James</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Centralna sekcija -->
  <div class="novosti order-m-3 mt-5">
    <div class="d-flex flex-wrap flex-row">
      <div class="akcija"><img src="../../assets/craft-beerfest.jpg"alt="MEGA AKCIJA"></div>
      <div class="novo"><img src="../../assets/walterego-red-ipa.jpg" alt="RED IPA"></div>
      <div class="novo"><img src="../../assets/uskoro.png" alt="BeerGarden craft USKORO!"></div>
      <div class="novo"><img src="../../assets/novipub.png" alt="Novi Pub u gradu!"></div>
      <div class="novo"><img src="../../assets/beershop.jpg" alt="BeerGarden Pub&Shop u pripremi"></div>
    </div>

  </div>

  <!-- Partneri sekcija -->
  <div class="saradnici order-m-1 p-2">
    <!-- Youtube link, Saradnici-->
  <div class="d-flex flex-wrap flex-column saradnici">
    <iframe class="mt-4" width="100%" src="https://www.youtube.com/embed/Dv3cCauzGlo" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    <h5 class="mt-3">Saradnici:</h5>
    <div class="card mt-3" style="width: 100%;">
      <div class="card-body">
        <h5 class="card-title">Gelender d.o.o.</h5>
        <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
        <a href="https://gelender.olx.ba/info" target="_blank" class="card-link">Gelender OLX</a>
      </div>
    </div>
    <div class="card mt-3" style="width: 100%;">
      <div class="card-body">
        <h5 class="card-title">NOVA RUNDA</h5>
        <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
        <a href="https://novarunda.com/" target="_blank" class="card-link">NOVA RUNDA</a>
      </div>
    </div>
  </div>
  </div>


</div>
<app-social></app-social>
